<template>
    <div v-loading="loading">
        <Cascader
            :data="cascaderList"
            :change-on-select="isChangeOnSelect"
            transfer
            v-model="currValue"
            @on-change="onSelectArea"
            :placeholder="placeholder"
            :disabled="disabled"
            filterable
        ></Cascader>
    </div>
</template>

<script>
import { apiGaodeTree } from '@/api/common';
export default {
    data() {
        return {
            loading: true,
            cascaderList: [],
        };
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        isChangeOnSelect: {
            type: Boolean,
            default: false,
        },
        isGetAddressTree: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: 'all',
        },
        placeholder: {
            type: String,
            default: '请选择地区',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        currValue: {
            get() {
                return this.value;
            },
            set(k) {
                this.$emit('input', k || []);
            },
        },
    },
    mounted() {
        this.getArea();
    },
    methods: {
        getArea() {
            apiGaodeTree().then(
                (res) => {
                    this.loading = false;
                    this.cascaderList = this.recursion(res);
                },
                () => {
                    this.loading = false;
                },
            );
        },
        //获取省市区
        recursion(data) {
            // console.log(data);
            let temparea = [];
            (data || []).map((item) => {
                let gaodeAreaDTO = item.gaodeAreaDTO;
                let tempEachArea = {};
                if (gaodeAreaDTO.level !== 'country') {
                    tempEachArea.value = gaodeAreaDTO.id;
                    tempEachArea.label = gaodeAreaDTO.name;
                    if (item.childCategoryList && this.type !== 'province') {
                        tempEachArea.children = this.recursion(item.childCategoryList);
                    }
                    temparea.push(tempEachArea);
                } else {
                    temparea = this.recursion(item.childCategoryList);
                }
            });
            return temparea;
        },
        onSelectArea(val, selectedData) {
            this.$emit('on-change', val, selectedData);
        },
        onSelectAreaList(val) {
            this.$emit('input', val);
        },
    },
};
</script>
